import React, { useCallback, useState } from "react";
import * as myConstList from "../Common/BaseUrl";
import Footer from "../Common/Footer";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import Nav from "../Common/Nav";
import DocumentMeta from "react-document-meta";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useLaunchpadAddMutation } from "../../redux/userApi";
import { useGetChainsQuery } from "../../redux/whiteListApi";

const baseUrl = myConstList.baseUrl;

const meta = {
  title: "LaunchPad Form | Green Crypto X  Exchange",
  description:
    "Green Crypto X  Exchange Live Makes The Buying And Selling Of Crypto Coin Way More Effective And Profitable. We Are A Low Cost Cyrpto Exchange In India Like Bitcoin And Dogecoin",
  canonical: "https://Green Crypto X.com",
  meta: {
    charset: "utf-8",
    name: {
      keywords:
        "BTC Exchange, Crypto Trading Platform, Best Crypto Converter, Indian Crypto Exchange",
    },
  },
};

const MAX_LOGO_BYTES = 2048000; // 2MB
const MAX_DOC_BYTES = 2048000; // 2MB
const MIN_FILE_BYTES = 10240; // 10KB

const LaunchPadForm = () => {
  // form fields
  const [name, setName] = useState("");
  const [shortName, setShortName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [website, setWebsite] = useState("");
  const [ICOPrice, setICOPrice] = useState("");
  const [sessionSupply, setSessionSupply] = useState("");
  const [maxPurchase, setMaxPurchase] = useState("");
  const [ICOStartDate, setICOStartDate] = useState("");
  const [ICOEndDate, setICOEndDate] = useState("");
  const [chain, setChain] = useState("");
  const [BSCChain, setBSCChain] = useState("");
  const [highlight, setHighlight] = useState("");
  const [strength, setStrength] = useState("");
  const [documentFile, setDocumentFile] = useState(null);
  const [logo, setLogo] = useState(null);
  const [userUploadLogo, setUserUploadLogo] = useState("");
  const [description, setDescription] = useState("");
  const [socialMediaObj, setSocialMediaObj] = useState([
    { platform: "", url: "" },
  ]);

  const [btnDisable, setBtnDisable] = useState(false);

  // individual error states preserved to avoid touching markup
  const [errorLogo, setErrorLogo] = useState("");
  const [errorName, setErrorName] = useState("");
  const [errorShortName, setErrorShortName] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorNumber, setErrorNumber] = useState("");
  const [errorWebsite, setErrorWebsite] = useState("");
  const [errorICOPrice, setErrorICOPrice] = useState("");
  const [errorSessionSupply, setErrorSessionSupply] = useState("");
  const [errorMaxPurchase, setErrorMaxPurchase] = useState("");
  const [errorStartDate, setErrorStartDate] = useState("");
  const [errorEndDate, setErrorEndDate] = useState("");
  const [errorChain, setErrorChain] = useState("");
  const [errorBSCchain, setErrorBSCchain] = useState("");
  const [errorHighlight, setErrorHighlight] = useState("");
  const [errorStrength, setErrorStrength] = useState("");
  const [errorDocument, setErrorDocument] = useState("");
  const [errorSocialMedia, setErrorSocialMedia] = useState("");
  const [errorDescription, setErrorDescription] = useState("");
  const [socialMediaObjError, setSocialMediaObjError] = useState([
    { platform: "", url: "" },
  ]);

  const [addLaunchpad] = useLaunchpadAddMutation();
  const { data: chainsData } = useGetChainsQuery();

  // Helpers for setting/clearing errors centrally
  const clearAllErrors = () => {
    setErrorLogo("");
    setErrorName("");
    setErrorShortName("");
    setErrorEmail("");
    setErrorNumber("");
    setErrorWebsite("");
    setErrorICOPrice("");
    setErrorSessionSupply("");
    setErrorMaxPurchase("");
    setErrorStartDate("");
    setErrorEndDate("");
    setErrorChain("");
    setErrorBSCchain("");
    setErrorHighlight("");
    setErrorStrength("");
    setErrorDocument("");
    setErrorSocialMedia("");
    setErrorDescription("");
    setSocialMediaObjError([{ platform: "", url: "" }]);
  };

  // validation helpers (put near top of component)
  const hasLeadingOrTrailingSpace = (v) => /^\s|\s$/.test(v);
  const hasThreeOrMoreConsecutiveSpaces = (v) => / {2,}/.test(v);
  const isOnlySpaces = (v) => /^\s*$/.test(v);

  const decimalMax8Regex = /^(\d{1,8})(\.\d{1,8})?$/; // up to 8 digits before and up to 8 after decimal
  const emailReg = /^([a-zA-Z\d\.\-+_]+)@([a-zA-Z\d\.-]+)\.([a-zA-Z]{2,})$/; // keep simple but strict
  const mobileReg = /^\d{6,15}$/;
  const websiteReg = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
  const evmContractRegex = /^0x[a-fA-F0-9]{40}$/;
  const tronContractRegex = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;
  const solContractRegex = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;

  // generic space/length validator
  const validateTextField = (
    value,
    { fieldLabel, min = 0, max = Infinity, allowSpaces = true }
  ) => {
    if (!value || isOnlySpaces(value)) return `Please enter ${fieldLabel}`;
    if (hasLeadingOrTrailingSpace(value))
      return `Please enter a valid ${fieldLabel}`;
    if (hasThreeOrMoreConsecutiveSpaces(value))
      return `Please enter a valid ${fieldLabel}`;
    if (value.length < min)
      return `${
        fieldLabel?.charAt(0)?.toUpperCase() + fieldLabel.slice(1)
      } must be at least ${min} characters`;
    if (value.length > max)
      return `${
        fieldLabel?.charAt(0)?.toUpperCase() + fieldLabel.slice(1)
      } must be at most ${max} characters`;
    return "";
  };

  const isEvmChain = (chainSymbol) =>
    ["BSC", "TBSC", "ETH", "TETH", "POL", "TPOL", "TYCO"].includes(
      chainSymbol
    );
  const isSolChain = (chainSymbol) => ["SOL", "TSOL"].includes(chainSymbol);
  const isTronChain = (chainSymbol) => ["TRX", "TTRX"].includes(chainSymbol);

  const getContractAddressError = (value, chainSymbol) => {
    if (!value || isOnlySpaces(value)) return "Please enter contract address";
    if (hasLeadingOrTrailingSpace(value))
      return "Please enter valid contract address";
    if (value.length > 100) return "Please enter valid contract address";
    if (!chainSymbol) return "Please select chain first";

    if (isEvmChain(chainSymbol)) {
      return evmContractRegex.test(value)
        ? ""
        : "Please enter valid EVM contract address";
    }
    if (isSolChain(chainSymbol)) {
      return solContractRegex.test(value)
        ? ""
        : "Please enter valid Solana contract address";
    }
    if (isTronChain(chainSymbol)) {
      return tronContractRegex.test(value)
        ? ""
        : "Please enter valid Tron contract address";
    }

    if (!/^[A-Za-z0-9_]+$/.test(value)) {
      return "Contract address can only contain letters, numbers, and underscores";
    }
    return "";
  };

  // unified input change (text, number, date, select)
  const handleInputChange = useCallback(
    (e) => {
      const { name, value: rawValue } = e.target;
      let value = rawValue;

      switch (name) {
        case "name": {
          setName(value);
          const err = validateTextField(value, {
            fieldLabel: "token name",
            min: 2,
            max: 35,
          });
          if (err) {
            setErrorName(err);
          } else if (!/^[A-Za-z0-9 ]+$/.test(value)) {
            // NEW RULE: only chars/numbers allowed (space permitted for multiple words)
            setErrorName("Token name can only contain letters and numbers");
          } else {
            setErrorName("");
          }
          break;
        }

        case "shortName": {
          const up = value.toUpperCase();
          setShortName(up);
          const err = validateTextField(up, {
            fieldLabel: "short name",
            min: 2,
            max: 8,
          });
          if (err) {
            setErrorShortName(err);
          } else if (!/^[A-Za-z0-9]+$/.test(up)) {
            // NEW RULE
            setErrorShortName(
              "Short name can only contain letters and numbers"
            );
          } else {
            setErrorShortName("");
          }
          break;
        }

        case "email": {
          setEmail(value);
          if (!value) {
            setErrorEmail("Please enter email");
          } else if (/\s/.test(value)) {
            setErrorEmail("Please enter valid email");
          } else if (value.length > 65) {
            setErrorEmail("Please enter valid email");
          } else if (!emailReg.test(value)) {
            setErrorEmail("Please enter valid email");
          } else {
            setErrorEmail("");
          }
          break;
        }

        case "mobile": {
          setNumber(value);
          if (!value) setErrorNumber("Please enter mobile number");
          else if (!mobileReg.test(value))
            setErrorNumber("Please enter valid mobile number");
          else setErrorNumber("");
          break;
        }

        case "website": {
          setWebsite(value);
          if (!value) {
            setErrorWebsite("Please enter website");
          } else if (value.length > 256) {
            setErrorWebsite("Website must be less than 256 characters");
          } else {
            // const regex = /^(https?:\/\/[^\s]+\.[a-z]{2,})$/i;
            // if (!regex.test(value)) {
            //   setErrorWebsite(
            //     "Please enter a valid website (http/https and valid domain)"
            //   );
            // } else {
            //   setErrorWebsite("");
            // }
          }
          break;
        }

        case "ICOPrice": {
          setICOPrice(value);
          if (!value) {
            setErrorICOPrice("Please enter valid ICO price");
          } else if (!decimalMax8Regex.test(value)) {
            setErrorICOPrice("Please enter valid ICO price");
          } else if (Number(value) <= 0) {
            setErrorICOPrice("Please enter valid ICO price");
          } else {
            setErrorICOPrice("");
          }
          break;
        }

        case "sessionSupply": {
          setSessionSupply(value);
          if (!value) {
            setErrorSessionSupply("Please enter valid session supply");
          } else if (!decimalMax8Regex.test(value)) {
            setErrorSessionSupply("Please enter valid session supply");
          } else if (Number(value) <= 0) {
            setErrorSessionSupply("Please enter valid session supply");
          } else if (maxPurchase && Number(value) < Number(maxPurchase)) {
            // NEW RULE: session supply > max purchase
            setErrorSessionSupply(
              "Session supply must be greater than max purchase amount"
            );
          } else {
            setErrorSessionSupply("");
          }
          break;
        }

        case "maxPurchase": {
          setMaxPurchase(value);
          if (!value) {
            setErrorMaxPurchase("Please enter valid max purchase amount");
          } else if (!decimalMax8Regex.test(value)) {
            setErrorMaxPurchase("Please enter valid max purchase amount");
          } else if (Number(value) <= 0) {
            setErrorMaxPurchase("Please enter valid max purchase amount");
          } else if (sessionSupply && Number(value) > Number(sessionSupply)) {
            // NEW RULE: max purchase < session supply
            setErrorMaxPurchase(
              "Max purchase amount must be less than session supply"
            );
          } else {
            setErrorMaxPurchase("");
          }
          break;
        }

        case "startDate": {
          setICOStartDate(value);
          if (!value) {
            setErrorStartDate("Please enter start date");
            break;
          }
          const start = new Date(value);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const year = start.getFullYear();
          if (year > 9999) {
            setErrorStartDate("Please enter valid year");
            break;
          }
          if (start < today) {
            setErrorStartDate("Start date cannot be before today");
            break;
          }
          if (ICOEndDate) {
            const end = new Date(ICOEndDate);
            if (start >= end) {
              setErrorStartDate("Start date must be before end date");
              setErrorEndDate("End date must be after start date");
              break;
            }
          }
          setErrorStartDate("");
          setErrorEndDate("");
          break;
        }

        case "endDate": {
          setICOEndDate(value);
          if (!value) {
            setErrorEndDate("Please enter end date");
            break;
          }
          const end = new Date(value);
          const year = end.getFullYear();
          if (year > 9999) {
            setErrorEndDate("Please enter valid date");
            break;
          }
          if (ICOStartDate) {
            const start = new Date(ICOStartDate);
            if (end <= start) {
              setErrorEndDate("End date must be after start date");
              setErrorStartDate("Start date must be before end date");
              break;
            }
          }
          setErrorStartDate("");
          setErrorEndDate("");
          break;
        }

        case "chain": {
          setChain(value);
          if (!value) {
            setErrorChain("Please select chain");
          } else {
            setErrorChain("");
          }
          if (BSCChain) {
            setErrorBSCchain(getContractAddressError(BSCChain, value));
          }
          break;
        }

        case "BSCChain": {
          setBSCChain(value);
          setErrorBSCchain(getContractAddressError(value, chain));
          break;
        }

        case "highlight": {
          setHighlight(value);
          const err = validateTextField(value, {
            fieldLabel: "project highlight",
            min: 10,
            max: 200,
          });
          if (err) {
            setErrorHighlight(err);
          } else if (!/^[A-Za-z0-9 ]+$/.test(value)) {
            // NEW RULE
            setErrorHighlight(
              "Project highlight can only contain letters and numbers"
            );
          } else {
            setErrorHighlight("");
          }
          break;
        }

        case "strength": {
          setStrength(value);
          const err = validateTextField(value, {
            fieldLabel: "project strength",
            min: 10,
            max: 200,
          });
          if (err) {
            setErrorStrength(err);
          } else if (!/^[A-Za-z0-9 ]+$/.test(value)) {
            // NEW RULE
            setErrorStrength(
              "Project strength can only contain letters and numbers"
            );
          } else {
            setErrorStrength("");
          }
          break;
        }

        case "description": {
          setDescription(value);
          const err = validateTextField(value, {
            fieldLabel: "description",
            min: 10,
            max: 300,
          });
          setErrorDescription(err || "");
          break;
        }

        default:
          break;
      }
    },
    [BSCChain, ICOEndDate, ICOStartDate, chain, maxPurchase, sessionSupply]
  );

  // file change handler (keeps your existing checks, preserved messages)
  const handleFileChange = useCallback((e) => {
    const { name, files } = e.target;
    const file = files && files[0] ? files[0] : null;

    if (name === "document") {
      if (!file) {
        setDocumentFile(null);
        setErrorDocument("Please select document");
        return;
      }
      if (!file.name.match(/\.(pdf)$/i)) {
        setDocumentFile(null);
        setErrorDocument("Please select valid input pdf");
        return;
      }
      if (file.size >= MAX_DOC_BYTES || file.size < MIN_FILE_BYTES) {
        setDocumentFile(null);
        setErrorDocument("Document size should be 10KB to 2MB");
        return;
      }
      setDocumentFile(file);
      setErrorDocument("");
    }

    if (name === "logo") {
      if (!file) {
        setLogo(null);
        setUserUploadLogo("");
        setErrorLogo("Please select logo");
        return;
      }
      if (!file.name.match(/\.(jpg|jpeg|png)$/i)) {
        setLogo(null);
        setUserUploadLogo("");
        setErrorLogo("Please select valid input jpg,jpeg,png");
        return;
      }
      if (file.size >= MAX_LOGO_BYTES || file.size < MIN_FILE_BYTES) {
        setLogo(null);
        setUserUploadLogo("");
        setErrorLogo("Logo size should be 10KB to 2MB");
        return;
      }
      setLogo(file);
      setUserUploadLogo(URL.createObjectURL(file));
      setErrorLogo("");
    }
  }, []);

  // prevent e/E, symbols for numeric inputs
  const handleValidation = (event) => {
    const forbidden = [
      "e",
      "E",
      "-",
      "+",
      "!",
      "@",
      "#",
      "$",
      "%",
      "^",
      "&",
      "*",
      "(",
      ")",
    ];
    if (forbidden.includes(event.key)) event.preventDefault();
  };

  const MAX_DOC_BYTES = 2 * 1024 * 1024; // 2MB
  const MAX_LOGO_BYTES = 2 * 1024 * 1024; // 2MB
  const MIN_FILE_BYTES = 10 * 1024; // 10KB

  const validateAll = () => {
    let isValid = true;
    clearAllErrors();

    const urlRegex = /^(https?:\/\/[^\s]+\.[a-z]{2,})$/i; // strict URL
    const alphaNumRegex = /^[A-Za-z0-9 ]+$/; // letters, numbers, spaces

    // token name
    if (!name) {
      setErrorName("Please enter token name");
      isValid = false;
    } else {
      const err = validateTextField(name, {
        fieldLabel: "token name",
        min: 2,
        max: 35,
      });
      if (err) {
        setErrorName(err);
        isValid = false;
      } else if (!alphaNumRegex.test(name)) {
        setErrorName("Token name can only contain letters and numbers");
        isValid = false;
      }
    }

    // short name
    if (!shortName) {
      setErrorShortName("Please enter short name");
      isValid = false;
    } else {
      const err = validateTextField(shortName, {
        fieldLabel: "short name",
        min: 2,
        max: 8,
      });
      if (err) {
        setErrorShortName(err);
        isValid = false;
      } else if (!/^[A-Za-z0-9]+$/.test(shortName)) {
        setErrorShortName("Short name can only contain letters and numbers");
        isValid = false;
      }
    }

    // email
    if (!email) {
      setErrorEmail("Please enter email");
      isValid = false;
    } else if (/\s/.test(email) || email.length > 65 || !emailReg.test(email)) {
      setErrorEmail("Please enter valid email");
      isValid = false;
    }

    // mobile number
    if (!number) {
      setErrorNumber("Please enter mobile number");
      isValid = false;
    } else if (!mobileReg.test(number)) {
      setErrorNumber("Please enter valid mobile number");
      isValid = false;
    }

    // website
    if (!website) {
      setErrorWebsite("Please enter website");
      isValid = false;
    } else if (website.length > 256) {
      setErrorWebsite("Website must be less than 256 characters");
      isValid = false;
    } else if (!urlRegex.test(website)) {
      // setErrorWebsite(
      //   "Please enter a valid website (http/https and valid domain)"
      // );
      // isValid = false;
    }

    // ICO price
    if (
      !ICOPrice ||
      !decimalMax8Regex.test(ICOPrice) ||
      Number(ICOPrice) <= 0
    ) {
      setErrorICOPrice("Please enter valid ICO price");
      isValid = false;
    }

    // session supply
    if (
      !sessionSupply ||
      !decimalMax8Regex.test(sessionSupply) ||
      Number(sessionSupply) <= 0
    ) {
      setErrorSessionSupply("Please enter valid session supply");
      isValid = false;
    } else if (maxPurchase && Number(sessionSupply) < Number(maxPurchase)) {
      // NEW RULE
      setErrorSessionSupply(
        "Session supply must be greater than max purchase amount"
      );
      isValid = false;
    }

    // max purchase amount
    if (
      !maxPurchase ||
      !decimalMax8Regex.test(maxPurchase) ||
      Number(maxPurchase) <= 0
    ) {
      setErrorMaxPurchase("Please enter valid max purchase amount");
      isValid = false;
    } else if (sessionSupply && Number(maxPurchase) > Number(sessionSupply)) {
      // NEW RULE
      setErrorMaxPurchase(
        "Max purchase amount must be less than session supply"
      );
      isValid = false;
    }

    // ICO start date
    if (!ICOStartDate) {
      setErrorStartDate("Please enter start date");
      isValid = false;
    } else {
      const start = new Date(ICOStartDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (start < today) {
        setErrorStartDate("Start date cannot be before today");
        isValid = false;
      }
      if (start.getFullYear() > 9999) {
        setErrorStartDate("Please enter valid year");
        isValid = false;
      }
      if (ICOEndDate) {
        const end = new Date(ICOEndDate);
        if (start >= end) {
          setErrorStartDate("Start date must be before end date");
          setErrorEndDate("End date must be after start date");
          isValid = false;
        }
      }
    }

    // ICO end date
    if (!ICOEndDate) {
      setErrorEndDate("Please enter end date");
      isValid = false;
    } else {
      const end = new Date(ICOEndDate);
      if (end.getFullYear() > 9999) {
        setErrorEndDate("Please enter valid year");
        isValid = false;
      }
      if (ICOStartDate) {
        const start = new Date(ICOStartDate);
        if (end <= start) {
          setErrorEndDate("End date must be after start date");
          setErrorStartDate("Start date must be before end date");
          isValid = false;
        }
      }
    }

    // chain
    if (!chain) {
      setErrorChain("Please select chain");
      isValid = false;
    }

    // contract address
    const contractErr = getContractAddressError(BSCChain, chain);
    if (contractErr) {
      setErrorBSCchain(contractErr);
      isValid = false;
    }

    // project highlight
    if (!highlight) {
      setErrorHighlight("Please enter project highlight");
      isValid = false;
    } else {
      const err = validateTextField(highlight, {
        fieldLabel: "project highlight",
        min: 10,
        max: 200,
      });
      if (err) {
        setErrorHighlight(err);
        isValid = false;
      } else if (!alphaNumRegex.test(highlight)) {
        // NEW RULE
        setErrorHighlight(
          "Project highlight can only contain letters and numbers"
        );
        isValid = false;
      }
    }

    // project strength
    if (!strength) {
      setErrorStrength("Please enter project strength");
      isValid = false;
    } else {
      const err = validateTextField(strength, {
        fieldLabel: "project strength",
        min: 10,
        max: 200,
      });
      if (err) {
        setErrorStrength(err);
        isValid = false;
      } else if (!alphaNumRegex.test(strength)) {
        // NEW RULE
        setErrorStrength(
          "Project strength can only contain letters and numbers"
        );
        isValid = false;
      }
    }

    // document
    if (!documentFile) {
      setErrorDocument("Please select document");
      isValid = false;
    } else if (!documentFile.name.match(/\.(pdf)$/i)) {
      setErrorDocument("Please select valid input pdf");
      isValid = false;
    } else if (
      documentFile.size >= MAX_DOC_BYTES ||
      documentFile.size < MIN_FILE_BYTES
    ) {
      setErrorDocument("Document size should be 10KB to 2MB");
      isValid = false;
    }

    // logo
    if (!logo) {
      setErrorLogo("Please select logo");
      isValid = false;
    } else if (!logo.name.match(/\.(jpg|jpeg|png)$/i)) {
      setErrorLogo("Please select valid input jpg,jpeg,png");
      isValid = false;
    } else if (logo.size >= MAX_LOGO_BYTES || logo.size < MIN_FILE_BYTES) {
      setErrorLogo("Logo size should be 10KB to 2MB");
      isValid = false;
    }

    // social media
    for (let i = 0; i < socialMediaObj.length; i++) {
      const element = socialMediaObj[i];
      const newErrs = [...socialMediaObjError];
      if (!element.url) {
        newErrs[i].url = "Please enter social link";
        isValid = false;
      } else if (!urlRegex.test(element.url)) {
        // newErrs[i].url = "Please enter valid URL (http/https and valid domain)";
        // isValid = false;
      } else {
        newErrs[i].url = "";
      }

      if (!element.platform || element.platform === "Please select") {
        newErrs[i].platform = "Please select social media";
        isValid = false;
      } else {
        newErrs[i].platform = "";
      }
      setSocialMediaObjError(newErrs);
    }

    // description
    if (!description) {
      setErrorDescription("Please enter description");
      isValid = false;
    } else {
      const err = validateTextField(description, {
        fieldLabel: "description",
        min: 10,
        max: 300,
      });
      if (err) {
        setErrorDescription(err);
        isValid = false;
      }
    }

    return isValid;
  };

  const submit = async (e) => {
    e.preventDefault();

    if (!validateAll()) return; // stop submit if errors

    // build FormData
    const formData = new FormData();
    formData.append("token_name", name);
    formData.append("short_name", shortName);
    formData.append("email", email);
    formData.append("mobile_number", number);
    formData.append("website", website);
    formData.append("ico_price", ICOPrice);
    formData.append("session_supply", sessionSupply);
    formData.append("max_purchase_amount", maxPurchase);
    formData.append("ico_start_date", ICOStartDate);
    formData.append("ico_end_date", ICOEndDate);
    formData.append("chain", chain);
    formData.append("contract_address", BSCChain);
    formData.append("project_highlight", highlight);
    formData.append("project_strength", strength);
    formData.append("document", documentFile);
    formData.append("logo", logo);
    formData.append("social_media", JSON.stringify(socialMediaObj));
    formData.append("description", description);

    try {
      setBtnDisable(true);
      const res = await addLaunchpad(formData).unwrap();
      toast.dismiss();
      toast.success(res.message || "Launchpad created successfully!");
      setTimeout(() => (window.location.href = "/launchPad"), 2000);
    } catch (err) {
      toast.dismiss();
      toast.error(err?.data?.message || "Something went wrong!");
      if (err?.data?.message === "Failed to authenticate token.") {
        setTimeout(() => (window.location.href = "/login"), 2000);
      }
      setBtnDisable(false);
    }
  };

  // Social media handlers
  const handleChangeSocial = useCallback(
    (i, e) => {
      const { name, value } = e.target;

      // update social media object
      const newVals = [...socialMediaObj];
      newVals[i] = { ...newVals[i], [name]: value };
      setSocialMediaObj(newVals);

      // update errors
      const newErrs = [...socialMediaObjError];

      if (name === "platform") {
        newErrs[i] = {
          ...newErrs[i],
          platform:
            !value || value === "Please select"
              ? "Please select social media"
              : "",
        };
      } else if (name === "url") {
      }

      setSocialMediaObjError(newErrs);
    },
    [socialMediaObj, socialMediaObjError]
  );

  const addFormFields = (e) => {
    if (socialMediaObj?.length >= 10) {
      toast.dismiss();
      toast.error("Cannot add more than 10 links");
      return;
    }
    e.preventDefault();
    setSocialMediaObj([...socialMediaObj, { platform: "", url: "" }]);
    setSocialMediaObjError([...socialMediaObjError, { platform: "", url: "" }]);
  };

  const removeFormFields = (i, e) => {
    e.preventDefault();
    const newFormValues = [...socialMediaObj];
    newFormValues.splice(i, 1);
    setSocialMediaObj(newFormValues);

    const newFormValuesError = [...socialMediaObjError];
    newFormValuesError.splice(i, 1);
    setSocialMediaObjError(newFormValuesError);
  };

  return (
    <div>
      <DocumentMeta {...meta}>
        <Nav graphColor="" />
        <div className="trade-volume">
          <div className="container">
            <div className="section-heading text-center">
              <h2>Launch Pad Form</h2>
            </div>
          </div>
        </div>
        <div className="listing-main">
          <div className="container">
            <div className="listing-outer">
              <div className="listing-form">
                <form onSubmit={submit}>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Token Name</label>
                        <input
                          type="text"
                          name="name"
                          onChange={handleInputChange}
                          value={name}
                          placeholder="Enter Token Name"
                          className="form-control"
                        />
                        <span style={{ color: "red" }}>{errorName}</span>
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Short Name</label>
                        <input
                          type="text"
                          name="shortName"
                          onChange={handleInputChange}
                          value={shortName}
                          placeholder="Enter Short Name"
                          className="form-control"
                        />{" "}
                        <span style={{ color: "red" }}>{errorShortName}</span>
                      </div>
                    </div>

                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Email</label>
                        <input
                          type="text"
                          name="email"
                          onChange={handleInputChange}
                          value={email}
                          placeholder="Enter Email"
                          className="form-control"
                        />
                        <span style={{ color: "red" }}>{errorEmail}</span>
                      </div>
                    </div>

                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Mobile Number</label>
                        <input
                          type="number"
                          name="mobile"
                          onChange={handleInputChange}
                          onKeyDown={handleValidation}
                          onWheel={(e) => e.currentTarget.blur()}
                          value={number}
                          placeholder="Enter Mobile Number"
                          className="form-control"
                        />
                        <span style={{ color: "red" }}>{errorNumber}</span>
                      </div>
                    </div>

                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Website</label>
                        <input
                          type="text"
                          name="website"
                          onChange={handleInputChange}
                          value={website}
                          placeholder="Enter Website"
                          className="form-control"
                        />
                        <span style={{ color: "red" }}>{errorWebsite}</span>
                      </div>
                    </div>

                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>ICO Price(USDT)</label>
                        <input
                          type="number"
                          name="ICOPrice"
                          onChange={handleInputChange}
                          onKeyDown={handleValidation}
                          onWheel={(e) => e.currentTarget.blur()}
                          value={ICOPrice}
                          placeholder="Enter ICO Price(USDT)"
                          className="form-control"
                        />
                        <span style={{ color: "red" }}>{errorICOPrice}</span>
                      </div>
                    </div>

                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Session Supply</label>
                        <input
                          type="number"
                          name="sessionSupply"
                          onChange={handleInputChange}
                          onKeyDown={handleValidation}
                          onWheel={(e) => e.currentTarget.blur()}
                          value={sessionSupply}
                          placeholder="Enter Session Supply"
                          className="form-control"
                        />
                        <span style={{ color: "red" }}>
                          {errorSessionSupply}
                        </span>
                      </div>
                    </div>

                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Max Purchase Amount</label>
                        <input
                          type="number"
                          name="maxPurchase"
                          onChange={handleInputChange}
                          onKeyDown={handleValidation}
                          onWheel={(e) => e.currentTarget.blur()}
                          value={maxPurchase}
                          placeholder="Enter Max Purchase Amount"
                          className="form-control"
                        />
                        <span style={{ color: "red" }}>{errorMaxPurchase}</span>
                      </div>
                    </div>

                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>ICO Start Date</label>
                        <input
                          type="date"
                          name="startDate"
                          onChange={handleInputChange}
                          value={ICOStartDate}
                          placeholder="Enter "
                          className="form-control"
                        />
                        <span style={{ color: "red" }}>{errorStartDate}</span>
                      </div>
                    </div>

                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>ICO End Date</label>
                        <input
                          type="date"
                          name="endDate"
                          onChange={handleInputChange}
                          value={ICOEndDate}
                          placeholder="Enter "
                          className="form-control"
                        />
                        <span style={{ color: "red" }}>{errorEndDate}</span>
                      </div>
                    </div>

                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Chain</label>
                        <select
                          name="chain"
                          onChange={handleInputChange}
                          value={chain}
                          className="form-control"
                        >
                          <option value="">Select</option>
                          {chainsData?.data?.map((chainItem) => (
                            <option
                              key={chainItem.chainId}
                              value={chainItem.chainSymbol}
                            >
                              {chainItem.chainName} ({chainItem.chainSymbol})
                            </option>
                          ))}
                        </select>
                        <span style={{ color: "red" }}>{errorChain}</span>
                      </div>
                    </div>

                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Contract Address</label>
                        <input
                          type="text"
                          name="BSCChain"
                          onChange={handleInputChange}
                          value={BSCChain}
                          placeholder="Enter Contract Address"
                          className="form-control"
                        />
                        <span style={{ color: "red" }}>{errorBSCchain}</span>
                      </div>
                    </div>

                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Project Highlight</label>
                        <input
                          type="text"
                          name="highlight"
                          onChange={handleInputChange}
                          value={highlight}
                          placeholder="Enter Project Highlight"
                          className="form-control"
                        />
                        <span style={{ color: "red" }}>{errorHighlight}</span>
                      </div>
                    </div>

                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Project Strength</label>
                        <input
                          type="text"
                          name="strength"
                          onChange={handleInputChange}
                          value={strength}
                          placeholder="Enter Project Strength"
                          className="form-control"
                        />
                        <span style={{ color: "red" }}>{errorStrength}</span>
                      </div>
                    </div>

                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Documents(Whitepaper) </label>
                        <input
                          type="file"
                          name="document"
                          placeholder=""
                          onChange={handleFileChange}
                          accept=".pdf"
                          className="form-control"
                        />
                        <span style={{ color: "red" }}>{errorDocument}</span>
                      </div>
                    </div>

                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Logo</label>
                        <input
                          type="file"
                          name="logo"
                          onChange={handleFileChange}
                          accept="image/*"
                          placeholder=""
                          className="form-control"
                        />
                        {userUploadLogo && (
                          <img
                            id="file-image"
                            src={userUploadLogo != false ? userUploadLogo : ""}
                            alt="Preview"
                            className="img-fluid"
                          />
                        )}
                        <span style={{ color: "red" }}>{errorLogo}</span>
                      </div>
                    </div>

                    {socialMediaObj.map((element, index) => (
                      <React.Fragment key={index}>
                        <div className="col-md-6 col-12">
                          <div className="form-group">
                            <label>Link</label>
                            <input
                              type="text"
                              name="url"
                              placeholder="Enter Link"
                              className="form-control"
                              value={element.url || ""}
                              onChange={(e) => handleChangeSocial(index, e)}
                            />
                            <p style={{ color: "red", margin: "0" }}>
                              {socialMediaObjError[index]?.url}
                            </p>
                          </div>
                        </div>

                        <div className="col-md-6 col-12">
                          <div className="add-row-group d-flex align-items-center justify-content-between lauch-from-grid">
                            <div className="form-group">
                              <label>Social Media</label>
                              <select
                                className="form-control"
                                name="platform"
                                value={element.platform || ""}
                                onChange={(e) => handleChangeSocial(index, e)}
                              >
                                <option value={"Please select"}>
                                  Please select
                                </option>
                                <option value={"Facebook"}>Facebook</option>
                                <option value={"Instagram"}>Instagram</option>
                                <option value={"LinkedIn"}>LinkedIn</option>
                                <option value={"Medium"}>Medium</option>
                                <option value={"Reddit"}>Reddit</option>
                                <option value={"Telegram"}>Telegram</option>
                                <option value={"X"}>X</option>
                              </select>
                              <p style={{ color: "red" }}>
                                {socialMediaObjError[index]?.platform}
                              </p>
                            </div>
                            <div className="add-row">
                              {index ? (
                                <button
                                  className="remove"
                                  onClick={(e) => removeFormFields(index, e)}
                                >
                                  -
                                </button>
                              ) : null}
                              <button
                                className="add-btn add"
                                onClick={(e) => addFormFields(e)}
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    ))}

                    <div className="col-12">
                      <div className="form-group">
                        <label>Description</label>
                        <textarea
                          placeholder="Enter Description"
                          onChange={handleInputChange}
                          name="description"
                          value={description}
                          className="form-control"
                        ></textarea>

                        <span style={{ color: "red" }}>{errorDescription}</span>
                      </div>
                    </div>

                    <div className="col-12 text-right">
                      <div className="save-cancel">
                        <button
                          type="submit"
                          className="btn btn-success"
                          disabled={btnDisable}
                        >
                          Submit
                        </button>

                        <Link className="btn btn-danger ml-3" to={"/launchPad"}>
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </DocumentMeta>
    </div>
  );
};

export default LaunchPadForm;
